import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {BaseDirectSaleVariant} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getOptionsFromActiveDirectSaleVariants = (
  directSaleVariants: BaseDirectSaleVariant[] | Nullish
): Option[] => {
  if (isNil(directSaleVariants)) {
    return [];
  }
  return directSaleVariants
    .filter((directSaleVariant) => directSaleVariant.isActive)
    .map((activeDirectSaleVariant) => ({
      label: activeDirectSaleVariant.name,
      value: activeDirectSaleVariant.directSaleVariantId,
    }));
};
